import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, MenuItem } from '@material-ui/core';
import { getInitials, stringToColor } from 'ui-utils';

class Option extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = (event) => {
    const { onSelect, option } = this.props;

    onSelect(option, event);
  };

  render() {
    const {
      isSelected,
      onFocus,
      option: { label },
    } = this.props;
    const name = label ? label.split(' - ')[0] : '';
    const initials = getInitials(name);
    const backgroundColor = stringToColor(name);

    return (
      <MenuItem
        component="div"
        onClick={this.handleClick}
        onFocus={onFocus}
        selected={isSelected}
        style={{ fontSize: 16, fontWeight: 500 }}
      >
        <Avatar style={{ fontWeight: 500, marginRight: 8, backgroundColor, height: 35, width: 35, color: 'white' }}>
          {initials}
        </Avatar>
        {label}
      </MenuItem>
    );
  }
}

Option.propTypes = {
  option: PropTypes.object,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  onFocus: PropTypes.func,
};

export default Option;
